import { createAction, props } from '@ngrx/store';

import { RestBulkScopeAndBidModel } from '@shared/interfaces/rest-bulk-scope-and-bid-model';
import { UpdateTypedAttachmentToEntityModel } from '@shared/interfaces/turnover.interface';

/**
 * get bulk scope list
 */
export const getBulkScopeList = createAction('[Turnover] get bulk scope list', props<{ propertyId: number }>());
export const getBulkScopeListSuccess = createAction(
  '[Turnover] get bulk scope list success',
  props<{ bulkList: RestBulkScopeAndBidModel[] }>()
);
export const getBulkScopeListFailed = createAction('[Turnover] get bulk scope list failed');

/**
 * get bulk scope
 */
export const getBulkScope = createAction('[Turnover] get bulk scope', props<{ bulkScopeId: number }>());
export const getBulkScopeSuccess = createAction(
  '[Turnover] get bulk scope success',
  props<{ bulkScope: RestBulkScopeAndBidModel }>()
);
export const getBulkScopeFailed = createAction('[Turnover] get bulk scope failed');

/**
 * update bulk scope
 */
export const updateBulkScope = createAction(
  '[Turnover] update bulk scope',
  props<{ bulkScope: RestBulkScopeAndBidModel }>()
);
export const updateBulkScopeSuccess = createAction('[Turnover] update bulk scope success');
export const updateBulkScopeFailed = createAction('[Turnover] update bulk scope failed');
export const resetUpdateBulkScopeStatus = createAction('[Turnover] reset Update Bulk Scope Status');

/**
 * Create new bulk scope
 */
export const createNewBulkScope = createAction(
  '[Turnover] Create new bulk scope',
  props<{ bulkScope: RestBulkScopeAndBidModel }>()
);
export const createNewBulkScopeSuccess = createAction(
  '[Turnover] Create new bulk scope success',
  props<{ bulkScopeId: number }>()
);
export const createNewBulkScopeFailed = createAction('[Turnover] Create new bulk scope failed');
export const resetNewBulkScopeID = createAction('[Turnover] reset new bulk scope id');

/**
 * Add units to bulk
 */
export const addUnitsToBulk = createAction(
  '[Turnover] add units to bulk',
  props<{ bulkScope: RestBulkScopeAndBidModel }>()
);
export const addUnitsToBulkSuccess = createAction('[Turnover] add units to bulk success');
export const addUnitsToBulkFailed = createAction('[Turnover] add units to bulk failed');

/**
 * Add bulk attachments
 */
export const addBulkTurnoversAttachment = createAction(
  '[Turnover] add bulk turnover attachment',
  props<{ attachment: UpdateTypedAttachmentToEntityModel }>()
);
export const addBulkTurnoversAttachmentSuccess = createAction('[Turnover] add bulk turnover attachment success');
export const addBulkTurnoversAttachmentFailed = createAction('[Turnover] add bulk turnover attachment failed');
